import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as l, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCameraTracking",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function h(e, t, i, u, _, a) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--camera-tracking"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Camera Tracking",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1A1.5 1.5 0 0 1 2.5 1h1a.5.5 0 0 1 0 1h-1ZM8 1.5a.5.5 0 0 1 .5-.5h1A1.5 1.5 0 0 1 11 2.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5ZM6 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM4 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-.268 2.982A2.5 2.5 0 0 1 5.5 6.25h1A2.5 2.5 0 0 1 9 8.75a.5.5 0 0 1-1 0 1.5 1.5 0 0 0-1.5-1.5h-1A1.5 1.5 0 0 0 4 8.75a.5.5 0 0 1-1 0 2.5 2.5 0 0 1 .732-1.768ZM1.5 8a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 1 0 1h-1A1.5 1.5 0 0 1 1 9.5v-1a.5.5 0 0 1 .5-.5Zm9 0a.5.5 0 0 1 .5.5v1A1.5 1.5 0 0 1 9.5 11h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const g = /* @__PURE__ */ s(c, [["render", h]]);
export {
  g as default
};
//# sourceMappingURL=camera-tracking.js.map
